module.exports = __webpack_public_path__ + "static/img/uranium-pellet_64.c24a9e3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/uranium-pellet_64.png
// module id = tlMh
// module chunks = 0